import type { ReadonlyDeep } from 'type-fest';

import { AccountingInfoInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { AccountingInfoFormValues } from '../hooks/useInitHandler.hook';

export function accountingInfoForm2ApiMapper(
  values: ReadonlyDeep<AccountingInfoFormValues>,
) {
  return pruneInput(values, AccountingInfoInput);
}
